<template>
    <div class="card">
            
        <div class="bg-blue-light p-1">
            <TitleButton 
                :showBtn="false"
                :showAddNew="true"
                title="CORONARY ANGIOGRAM (CAG) / PCI REPORT"
                btnTitle="List"
                @onClickCloseButton="onClickCloseButton"
                @onClickAddNewButton="onClickAdd"
            />
        </div>

        <div class="d-flex justify-content-center">
            <img class="cover-photo" :src="companyInfo.cover_photo" alt="">
        </div>

        <div >
            <PatientProfile 
                v-if="infoLoaddedStatus === 'done'"
                :doctors="admittedByUsers"
                v-model:profileId="formData.contact_profile_id"
                :isDisabled="Boolean($route.params.admissionId)"
                :class="$route.params.admissionId ? 'disabled-element' : ''"
            />
        </div>

        <div class="row px-1">
            <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                <label for="colFormLabel" class="form-label"><span class="required">*</span> Date of procedure</label>
                <div class="input-group input-group-merge w-100">
                    <input
                        v-model="formData.admission_date"
                        name="datetime"
                        type="datetime-local"
                        class="form-control"
                    />
                </div>
            </div>

            <div class="col-12 col-sm-6 col-md-6 col-lg-2">
                <label for="colFormLabel" class="form-label"> Word / Bed No: </label>
                <vField
                    v-model="formData.ward_bed_details"
                    name="media_cd_no"
                    type="text"
                    class="form-control"
                />
                <v-select
                    v-if="false"
                    placeholder="Select bed/cabin" class="w-100"
                    :options="beds" label="name" 
                    :reduce="(name) => name.id"
                    v-model="formData.service_resource_id"
                    :selectable="bed => bed.service_general_status === 'open'"
                >
                    <template v-slot:option="bed">
                        {{ bed.name }}
                        <span class="badge badge-light-dark font-small-3">{{ bed.service_general_status }}</span>
                    </template>
                </v-select>
            </div>

            <div class="col-12 col-sm-6 col-md-6 col-lg-2">
                <label class="form-label" for="media_cd_no">CD No</label>
                <vField
                    v-model="metaData.media_cd_no"
                    name="media_cd_no"
                    type="text"
                    class="form-control"
                />
            </div>

            <div class="col-12 col-sm-6 col-md-6 col-lg-2">
                <label class="form-label" for="hospital_ref">Hospital ID</label>
                <vField
                    v-model="formData.hospital_ref"
                    name="hospital ref"
                    type="text"
                    class="form-control"
                />
            </div>
        </div>
        <hr>
        <div class="row px-1">
            <div class="col-12 col-sm-4 col-md-4 col-lg-2">
                <label class="form-label" for="height">Height (CM)</label>
                <vField
                    v-model="phcNotes.height"
                    name="height"
                    type="number"
                    class="form-control"
                />
            </div>

            <div class="col-12 col-sm-4 col-md-4 col-lg-2">
                <label class="form-label" for="weight">Weight (KG)</label>
                <vField
                    v-model="phcNotes.weight"
                    name="weight"
                    type="number"
                    class="form-control"
                />
            </div>

            <div class="col-12 col-sm-4 col-md-4 col-lg-2">
                <label class="form-label" for="bmi">BMI</label>
                <vField
                    v-model="bmiCal"
                    placeholder="bmi"
                    name="bmi"
                    type="number"
                    class="form-control"
                    readonly
                />
            </div>

            <div class="col-12 col-sm-4 col-md-4 col-lg-2">
                <label class="form-label" for="weight">Hip / Waist Ratio</label>
                <vField
                    v-model="phcNotes.hip_weist_ratio"
                    name="ratio"
                    type="number"
                    class="form-control"
                />
            </div>

            <div class="col-12 col-sm-4 col-md-4 col-lg-2">
                <label class="form-label" for="weight">BSA (M2)</label>
                <vField
                    v-model="phcNotes.bsa"
                    name="bsa"
                    type="text"
                    class="form-control"
                />
            </div>
        </div>
        <hr>
        <div class="row note-section mt-0">
          <div class="col-12 col-md-6 py-1">
            <div
              v-for="(group, groupIndex) in leftNoteTypes"
              :key="group.title"
            >
              <h4 class="mb-2">{{ group.title }}</h4>
              <div
                v-for="(note, noteIndex) in group.notes"
                :key="note.value"
              >
                <AdmissionNote
                  ref="noteRefs"
                  :note="note"
                  :index="noteIndex"
                />
              </div>
            </div>
          </div>
      
          <div class="col-12 col-md-6 py-1">
            <div
              v-for="(group, groupIndex) in rightNoteTypes"
              :key="group.title"
            >
              <h4 class="mb-2 text-capitalize">{{ group.title }}</h4>
              <div
                v-for="(note, noteIndex) in group.notes"
                :key="note.value"
              >
                <AdmissionNote
                  ref="noteRefs"
                  :note="note"
                  :index="noteIndex"
                />
              </div>
            </div>

            <div class="row justify-content-between mt-5">
                <div class="col-6">
                    <label for="colFormLabel" class="col-form-label"> Operation Doctor </label>
                    <v-select 
                        placeholder="Select Referred Doctor" class="w-100" 
                        :options="consultants" label="name"
                        :reduce="(name) => name.id" 
                        v-model="formData.human_resource_id"
                    />
                </div>
                <div class="col-6">
                    <label for="colFormLabel" class="col-form-label"> Doctor </label>
                    <v-select 
                        placeholder="Select Admitting Doctor" class="w-100" 
                        :options="admittedByUsers" label="name"
                        :reduce="(name) => name.id"
                        v-model="formData.admitted_by"
                    />
                </div>
            </div>
          </div>
        </div>
       
        <div class="row">
            <div v-if="infoLoaddedStatus === 'loading'" class="col-12 col-sm-3 col-md-4 col-lg-4">
                <Loader />
            </div>

            <div class="col-12 text-center mb-3">
                <hr>
                <button :disabled="loading" @click="submit" type="submit" class="btn btn-primary me-1 mt-1 waves-effect waves-float waves-light">
                    <div v-if="loading" class="spinner-border spinner-border-sm text-light" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                    <span v-if="!loading">
                        <i class="fas fa-plus"></i>
                    </span>
                    
                    {{ loading ? 'Please wait...' : 'Save' }}
                </button>
            </div>
        </div>
        <Loader v-if="loading"/>
    </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton';
import { inject, onMounted, reactive, ref, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { getCurrentDateTime, json_string_parse } from '@/services/utils/global.js'
import { useStore } from 'vuex';
import handleHospital from '@/services/modules/hospital'
import AdmissionNote from '@/components/molecule/company/hospital/cag-pci/AdmissionNote.vue';
import PatientProfile from '@/components/molecule/company/hospital/cag-pci/PatientProfile.vue'
import handleContact from '@/services/modules/contact'
import Loader from "@/components/atom/LoaderComponent";
import handleCompany from "@/services/modules/company";
import cagPdfHelper from "@/services/utils/pdf/cagPdfHelper.js";

const $router = useRouter();
const $route = useRoute();
const store = useStore();
const singleNote = ref(null);
const loading = ref(false);
const loader = ref(false);
const consultants = reactive([]);
const beds = reactive([]);
const admittedByUsers = reactive([]);
const nurses = reactive([]);
const departments = reactive([]);
const noteTypes = reactive([]);
const noteRefs = ref([]);
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const infoLoaddedStatus = ref('loading');
const referrer = ref(null);
const companyInfo = ref({});

const {
    fetchServiceList,
    fetchDepartList,
    fetchAdmissionNoteList,
    storeRegistration,
    updateRegistration,
    fetchSingleNote,
    bmiCalculator
} = handleHospital()

const { fetchContactProfiles } = handleContact();
const { fetchCompanyInfo } = handleCompany();
const { generatePdf } = cagPdfHelper();

const formData = ref({
    company_id: $route.params.companyId,
    human_resource_id: null,
    service_resource_id: null,
    contact_profile_id: null,
    admitted_by: null,
    nurse_id: null,
    admission_date: getCurrentDateTime(),
    department_id: null,
    referrer_id: null,
    phc_notes: {},
    meta_data: {},
    notes: [],
    status: 'active',
    hospital_ref: '',
    ward_bed_details: '',
    type: 'cag_pci'
})

const metaData = ref({
    media_cd_no: '',
    master_system_identifier: ''
});

const phcNotes = ref({
    company_id: $route.params.companyId,
    height: 0,
    weight: 0,
    bmi: 0,
    hip_weist_ratio: 0,
    bsa: '',
});

const bmiCal = computed(() => bmiCalculator(phcNotes.value.height, phcNotes.value.weight) ? 
                            bmiCalculator(phcNotes.value.height, phcNotes.value.weight) : 0);

const submit = async () => {
    if (loading.value) return;

    loading.value = true;

    try {
        const notes = collectNoteData();
        const admissionId = $route.params.admissionId;
        
        formData.value.notes = notes;
        phcNotes.value.bmi = bmiCal.value;
        formData.value.referrer_id = referrer.value ? referrer.value.id : null;
        formData.value.phc_notes = phcNotes.value;
        formData.value.meta_data = metaData.value;
        
        const regMethod = admissionId ? updateRegistration : storeRegistration;
        const res = await regMethod(formData.value, admissionId);

        if (!res.status) {
          showError(res.message);
          return;
        }

        showSuccess(res.message);
        onClickCloseButton();
        await goToPrint(res.data.id);
    } catch (err) {
        console.log(err);
    } finally {
        loading.value = false;
    }
}

const collectNoteData = () => {
    const notes = [];
    noteRefs.value.forEach((noteRef) => {
        const noteData = noteRef.getNoteData();
        if(noteData.type && noteData.note) {
            notes.push(noteData);
        }
    });
    return notes;
}

const goToPrint = async (id) => {
    await generatePdf(id, $route.params.companyId)
}

const getCompanyInfo = async () => {
    await fetchCompanyInfo($route.params.companyId).then((res) => {
        companyInfo.value = res.data
    })
}

const onClickCloseButton = () => {
    $router.push({name: 'admission-discharge',
        params: {
            companyId: $route.params.companyId,
            moduleId: $route.params.moduleId,
            menuId: $route.params.menuId,
            pageId: $route.params.pageId,
        },
        query: $route.query,
    })
}

function getQuery() {
    let query = `?company_id=${$route.params.companyId}&search_type=all&type=cag`;
    return query;
}

const getSingleIpdRegister = async (id = null, from = null) => {
    if(!id){
        infoLoaddedStatus.value = 'done';
        return;
    };

    let query = getQuery();

    await fetchSingleNote(query, id).then((res) => {
        if (!res.status) return showError(res.message);
        formData.value = res.data;
        if(res.data.phc_general) {
            phcNotes.value = {
                height: res.data.phc_general.height,
                weight: res.data.phc_general.weight,
                bmi: res.data.phc_general.bmi,
                hip_weist_ratio: res.data.phc_general.hip_weist_ratio,
                bsa: res.data.phc_general.bsa,
            }
        }
        if(res.data.meta_data) {
            metaData.value = res.data.meta_data;
        }
        referrer.value = res.data.referrer;

        if(from === 'pdf'){
            infoLoaddedStatus.value = 'done';
            return;
        }

        setNoteData(res.data.notes)
        infoLoaddedStatus.value = 'done';
    })
}

const setNoteData = (notes) => {
  noteTypes.forEach(group => {
    group.notes.forEach(note => {
      const matchedNote = notes.find(n => n.type === note.value);
      if(matchedNote) {
        note.id = matchedNote.id ?? null;
        note.note_names = matchedNote.note ?? [];
      }
    });
  });
};

const onClickAdd = () => {
    $router.push({name: 'admission-discharge',
        params: $route.params,
        query: $route.query,
    })
}

onMounted( async () => {
    const query = getQuery();
    const admissionId = $route.params.admissionId;
    
    loader.value = true;
    await Promise.all([
        fetchServiceList(query, 'human_resources').then((res) => {
            if(res.data && res.data.length > 0) {
                consultants.push(...res.data)
                formData.value.human_resource_id = res.data[0].id;
            }
        }),
        fetchServiceList(query, 'places').then((res) => {
            if(res.status) {
                beds.push(...res.data);
                processInitialData(res.data);
            } 
        }),
        fetchContactProfiles(query + `&type=nurse`).then((res) => {
            if(res.status) nurses.push(...res.data)
        }),
        fetchContactProfiles(query + `&type=doctor`).then((res) => {
            if(res.data && res.data.length > 0) {
                admittedByUsers.push(...res.data);
                formData.value.admitted_by = res.data[0].id
            } 
        }),
        fetchDepartList(query).then((res) => {
            if(res.status) departments.push(...res.data)
        }),
        fetchAdmissionNoteList(query).then((res) => {
            if(res.status) noteTypes.push(...res.data)
        }),
        getCompanyInfo()
    ]).then(() => {
        getSingleIpdRegister(admissionId);
        loader.value = false;
    }).catch((err) => {
        loader.value = false
    });
})

const processInitialData = (data) => {
  formData.value.service_resource_id = data[0].id;
}

const leftNoteTypes = computed(() => {
  return noteTypes.slice(0, 3);
});

const rightNoteTypes = computed(() => {
  return noteTypes.slice(3);
});
</script>

<style scoped>
.note-section {
    margin-top: 2%;
    box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);
    width: 96%;
    margin-left: 2%;
}
.cover-photo {
    width: 100%;
    object-fit: cover;
}
</style>